<ion-app>
  <ion-router-outlet (stackDidChange)="stackChanged()" id="my-outlet"></ion-router-outlet>
</ion-app>
